import React from 'react';
import Spacer from 'evcharging/components/Spacer';
import Container from 'evcharging/components/Container';
import Section from 'evcharging/containers/layout/Section';
import Responsible from 'evcharging/components/Responsible';
import Box from 'evcharging/components/Box';
import Title from 'evcharging/components/Title';
import Paragraph from 'evcharging/components/Paragraph';
import Image from 'next/image';
import useI18n from 'evcharging/hooks/useI18n';
import { MobileAppImage, WebAppImage } from 'evcharging/assets/ev-software';

const WebMobileApp = () => {
  const { t } = useI18n();
  return (
    <Section>
      <Container>
        <Spacer value={0} mobile={24} />
        <Responsible fractions={[40, 51]}>
          <Box>
            <Spacer value={16} />
            <Title variant={'h2'}>{t('software.title1')}</Title>
            <Spacer value={16} />
            <Paragraph color={'middle'} maxWidth={522}>
              {t('software.text1')}
            </Paragraph>
            <Spacer value={24} />
          </Box>
          <Image src={WebAppImage} alt={t('software.remote.alt')} width={678} height={294} />
        </Responsible>
        <Spacer value={155} mobile={32} />
        <Responsible fractions={[35, 49]} mobileReverse>
          <Box display={'flex'} justifyContent={'flex-end'}>
            <Image src={MobileAppImage} alt={t('software.analysis.alt')} width={353} height={560} />
          </Box>
          <Box display={'flex'} flexDirection={'column'} justifyContent={'center'}>
            <Title variant={'h2'} maxWidth={413}>
              {t('software.title2')}
            </Title>
            <Spacer value={16} />
            <Paragraph color={'middle'} maxWidth={522}>
              {t('software.text2')}
            </Paragraph>
            <Spacer value={24} />
          </Box>
        </Responsible>
      </Container>
    </Section>
  );
};

export default WebMobileApp;
